<template>
  <div class="water-box" id="waterBox">
    <div v-if='showBtn' class="content-label" :style="[{ backgroundColor: '#4d78da' }]"
         @click="backMap">
			<span>
				返回
			</span>
      <span>
				地图
			</span>
    </div>
    <div class="headers">
      <div class="site-img">
        <img :src="siteDetail.photo ? siteDetail.photo : noneImg" preview="2" alt="" />
      </div>
      <div class="site-right">
        <div class="site-info">
          <div class="site-info-detail">
            <div class="site-info-detail-top">
              <img
                v-if="siteDetail.onlineStatus"
                src="@/assets/others/index/wifi2.gif"
                :title="[siteDetail.onlineStatus ? '站点在线' : '站点离线']"
                style="width: 40px; height: 35px; margin-right: 10px"
              />
              <img
                v-if="!siteDetail.onlineStatus"
                src="@/assets/others/index/wifi5.gif"
                :title="[siteDetail.onlineStatus ? '站点在线' : '站点离线']"
                style="width: 44px; height: 40px; margin-right: 10px"
              />
              <div
                class="site-name"
                style="cursor: pointer"
                :title="[siteDetail.onlineStatus ? '站点在线' : '站点离线']"
              >
                {{ siteDetail.name }}
              </div>
            </div>
            <div class="site-info-detail-center">
              <div class="iconfont icon-area"></div>
              <div class="site-name">{{ siteDetail.areaFullName }}</div>
            </div>
            <div class="site-info-detail-bottom" v-if="siteDetail.riverFullName">
              <div class="iconfont icon-heliu"></div>
              <div class="site-name">{{ siteDetail.riverFullName }}</div>
            </div>
          </div>
          <div style="display: flex; width: 96%; justify-content: space-between; margin-left: 2%">
            <div class="site-items">
              <!-- <div class="iconfont icon-shishijiance" style="font-size: 96px;"></div> -->
              <img src="@assets/others/index/warn.png" style="width: 2.5vw" />
              <div class="site-details">
                <span style="font-size: 1.8rem; color: #0ff; margin-top: 1vh; font-family: 'UnidreamLED'">
                  <!-- {{
                    siteDetail.warnSum
                  }} -->
                    0
                  </span>
                <span style="font-size: 0.8rem">预警数量</span>
              </div>
            </div>
            <div class="site-items">
              <img src="@assets/others/index/time.png" style="width: 2.5vw" />
              <div class="site-details">
                <span style="font-size: 1.8rem; color: #0ff; margin-top: 15px; font-family: 'UnidreamLED'"
                >{{ siteDetail.commSum }}</span
                >
                <span style="font-size: 0.8rem">每日应检测数量</span>
              </div>
            </div>
            <div class="site-items">
              <img src="@assets/others/index/monitor.png" style="width: 2.5vw" />
              <div class="site-details">
                <span style="font-size: 1.8rem; color: #0ff; margin-top: 15px; font-family: 'UnidreamLED'"
                >{{ siteDetail.onlineSum }}</span
                >
                <span style="font-size: 0.8rem">今日已检测数量</span>
              </div>
            </div>
            <div class="site-items">
              <img src="@assets/others/index/upload.png" style="width: 2.5vw" />
              <div class="site-details">
                <span style="font-size: 1.8rem; color: #0ff; margin-top: 15px; font-family: 'UnidreamLED'">{{
                    siteDetail.lastOnlineRatio
                  }}</span>
                <span style="font-size: 0.8rem">昨日数据上传率</span>
              </div>
            </div>
            <div class="site-items">
              <img src="@assets/others/index/time.png" style="width: 2.5vw" />
              <div class="site-details" style="line-height: 20px; justify-content: center">
                <span
                  style="
                    font-size: 1.4rem;
                    color: #0ff;
                    margin-top: 15px;
                    font-family: 'UnidreamLED';
                    text-align: center;
                  "
                >{{ siteDetail.lastTime ? siteDetail.lastTime : '---' }}</span
                >
                <span style="font-size: 0.8rem; text-align: center">最后检测时间</span>
              </div>
            </div>
          </div>
          <div class="site-info-tab" v-if="false">
            <div class="site-tab-left">
              <div class="iconfont icon-shishidaping"></div>
              <div class="site-tab-name">24H</div>
            </div>
            <div class="site-tab-right">
              <div class="site-tab-title">{{ siteDetail.warnSum }}</div>
              <div class="site-tab-num">预警数量</div>
            </div>
          </div>
          <div class="site-info-tab" v-if="false">
            <div class="site-tab-left">
              <div class="iconfont icon-shishidaping"></div>
              <div class="site-tab-name">24H</div>
            </div>
            <div class="site-tab-right">
              <div class="site-tab-title">{{ siteDetail.onlineSum }}</div>
              <div class="site-tab-num">检测数量</div>
            </div>
          </div>
          <div class="site-info-tab" v-if="false">
            <div class="site-tab-left">
              <div class="iconfont icon-shishidaping"></div>
              <div class="site-tab-name">24H</div>
            </div>
            <div class="site-tab-right">
              <div class="site-tab-title">{{ siteDetail.lastOnlineRatio }}</div>
              <div class="site-tab-num">数据上传率</div>
            </div>
          </div>
          <div class="site-info-tab" v-if="false">
            <div class="site-tab-left">
              <div class="iconfont icon-shishidaping"></div>
              <div class="site-tab-name">24H</div>
            </div>
            <div class="site-tab-right">
              <div class="site-tab-title" style="line-height: 17px; padding-top: 10px; font-size: 20px">
                {{ siteDetail.lastTime }}
              </div>
              <div class="site-tab-num">最后检测时间</div>
            </div>
          </div>
        </div>
        <div class="site-nav">
          <div
            :class="{ 'nav-item': true, current: currentItem == item }"
            v-for="(item, index) in navList"
            :key="index"
            @click="onTabChange(item)"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <div class="tab-content">
      <waste-water
        ref="water"
        :selectId="selectId"
        :selectType="selectType"
        v-if=" currentItem == '站点概览'"
      ></waste-water>

      <div v-else-if="currentItem == '视频监控'">
        <!--      租户部分  start-->

        <video-temp ref="video" :siteId="siteId" v-if="tenantCode==28 || selectType==60"></video-temp>
        <!--      租户部分  end-->
        <video-item ref="video" :siteId="selectId" v-else></video-item>
      </div>
      <smoke-monitoring :showSiteTree='showSiteTree' :siteId="siteId" v-else-if="currentItem == '烟雾检测'"></smoke-monitoring>
      <real-time-data :showSiteTree='showSiteTree' :siteId="siteId" v-else-if="currentItem == '监测数据'"></real-time-data>
      <real-time-report :showSiteTree='showSiteTree' :siteId="siteId" :selectType='selectType' v-else-if="currentItem == '数据报表'"></real-time-report>
      <line-chart :showSiteTree='showSiteTree' :siteId="siteId" v-else-if="currentItem == '图表分析'"></line-chart>
      <enterpris-env :showSiteTree='showSiteTree' :companyId="siteDetail.companyId" v-else-if="currentItem == '企业环保档案'"></enterpris-env>
    </div>
  </div>
</template>
<script>
// 租户部分  start
import videoTemp from '@/views/dashboard/com/videoTemp.vue'
import hydrologyTemp from '@/views/dashboard/st61/hydrologyTemp.vue'
// 租户部分  end

import wasteWater from '@/views/yongchun/dashboard/com/wasteWater.vue'
import realTimeData from '@/views/yongchun/dashboard/com/realTimeData.vue'
import lineChart from '@views/yongchun/dashboard/com/LineChart.vue'
import realTimeReport from '@views/yongchun/dashboard/com/realTimeReport.vue'
import videoItem from '@/views/dashboard/com/video.vue'
import hydrology from '@/views/dashboard/st61/hydrology.vue'
import smartEnergy from '@/views/dashboard/st54/smartEnergy.vue'
import soil from '@/views/dashboard/st35/wasteWater.vue'
import siteFiles from '@/views/dashboard/com/siteFiles.vue'
import { queryBigDataById, queryUrlBySiteId } from '@/api/api'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import noneImg from '@/assets/others/index/none2.png'
import PathReview from '@/views/dashboard/com/pathReview'
import operationFiles from '@/views/dashboard/com/operationFiles.vue'
import enterprisEnv from '@/views/dashboard/st32/enterprisEnv.vue'

import { getAction } from '@/api/manage'
import smokeMonitoring from '@views/yongchun/dashboard/com/smokeMonitoring.vue'


export default {
  data() {
    return {
      tenantCode:window.localStorage.getItem('tenant'),
      showPath: false,
      widthChange: true,
      noneImg,
      frameUrl: '',
      currentItem: '站点概览',
      navList: ['站点概览', '视频监控', '监测数据', '数据报表','图表分析','企业环保档案'],
      selectId: '0',
      siteDetail: {},
      operationData:{},
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view',
      },
      selectType: '0',
      siteId: '',
      timer: null,
      currentPlanSum: 0,
      onlineRatio: ''
    }
  },
  components: {
    smokeMonitoring,
    videoTemp,
    hydrologyTemp,
    PathReview,
    siteFiles,
    soil,
    videoItem,
    hydrology,
    smartEnergy,
    wasteWater,
    operationFiles,
    enterprisEnv,
    realTimeData,
    lineChart,
    realTimeReport
  },
  props: {
    showBtn:{
      type: Boolean,
      default: true
    },
    showSiteTree:{
      type: Boolean,
      default: true
    }
  },
  created() {
    window.addEventListener(
      'resize',
      () => {
        this.widthChange = false
        this.timer = setTimeout(() => {
          this.widthChange = true
        }, 100)
      },
      false
    )
    // this.currentPlanSum = this.hoursUntilMidnight() * 60
  },
  destroyed() {
    clearTimeout(this.timer)
  },
  watch: {
    selectType:{
      handler(value){
        if(value == 22) {
          this.navList = ['站点概览', '视频监控','烟雾检测', '监测数据', '数据报表','图表分析','企业环保档案']
        }else{
          this.navList = ['站点概览', '视频监控', '监测数据', '数据报表','图表分析','企业环保档案']
        }
        this.currentItem = '站点概览'
      },
      immediate: true,
      deep:true
    }
  },
  methods: {
    hoursUntilMidnight(){
      const now = new Date()
      const midNight =  new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
      const diff = now.getTime() - midNight.getTime()
      const hours = Math.ceil(diff / (1000 * 60 * 60))
      return hours
    },
    backMap(){
      this.$bus.$emit('showSite', 'show', false)
      this.$router.push({
        path: '/monitor/mapYc',
        query: {
          companyId:this.siteDetail.companyId
        },
      })
    },
    onTabChange(item) {
      this.currentItem = item
      if (item == '实时数据' || item == '监测数据' || item == '站点档案') {
        let data1 = JSON.parse(JSON.stringify(this.selectId))
        this.selectId = '0'
        this.$nextTick(() => {
          this.selectId = data1
        })
      }
      if (item == '视频监控') {
        this.$nextTick(() => {
          console.log('this.$refs.video',this.selectType)
          this.$refs.video?this.$refs.video.getVideoList(this.siteId):''
        })
      }
      if (item == '三维工况') {
        this.$nextTick(() => {
          this.$refs.video.getVideoList(this.siteId)
        })
      }
    },
    getType(data,res) {
      console.log('getType-data',data)
      this.selectType = data.siteType
      this.siteId = data.siteId
      res?this.handleSiteData(res):this.getsiteDetail(data.siteId)

      queryUrlBySiteId(data.siteId)
        .then((res) => {
          if (res.result) {
            this.frameUrl = res.result
          } else {
            this.frameUrl =
              'https://www.skyray-water.com:4001/view/yesep_env/3?site_id=' +
              value +
              '&isCron=1&token=' +
              Vue.ls.get(ACCESS_TOKEN)
          }
        })
        .catch(() => {
          this.frameUrl =
            'https://www.skyray-water.com:4001/view/yesep_env/3?site_id=' +
            this.siteId +
            '&isCron=1&token=' +
            Vue.ls.get(ACCESS_TOKEN)
        })
      this.$nextTick(() => {
        // this.getsiteDetail(data.siteId)
        this.getOperationData(data.siteId)
        if (this.currentItem == '视频监控') {
          this.$refs.video.getVideoList(data.siteId)
        }
        this.selectId = data.siteId.toString()
      })
    },
    getOperationData(id){
      let params ={
        siteId: id
      }
      getAction('site/info/devops/getBySite',params).then(res => {
        if (res.success) {
          this.operationData = res.result
        }
      })
    },
    getsiteDetail(id) {
      queryBigDataById({
        id,
      }).then((res) => {
        this.handleSiteData(res)
      })
    },
    handleSiteData(res){
      if (res.success) {
        this.showPath = false
        res.result.photo = res.result.photo != null ? this.getImageView(res.result.photo) : ''
        this.siteDetail = res.result
        // this.onlineRatio = Number((this.siteDetail.onlineSum / this.currentPlanSum) * 100).toFixed(2) + '%'
        if (res.result.st == 21 && (res.result.category == '2' || res.result.category == '3')) {
          setTimeout(() => {
            this.showPath = true
          })
        } else if(res.result.st == 31){
          if (this.currentItem == '路径回放') {
            this.onTabChange('实时数据')
          }
        }else {
          if (this.currentItem == '路径回放') {
            this.onTabChange('实时数据')
          }
        }
      }
    },
    getImageView(photo) {
      return this.url.imgerver + '/' + photo
    },
  },
}
</script>
<style>
@font-face {
  font-family: 'UnidreamLED';
  src: url(../../../../assets/font/UnidreamLED.eot);
  /***兼容ie9***/
  src: url(../../../../assets/font/UnidreamLED.eot?#iefix) format('embedded-opentype'),
    /***兼容ie6-ie8***/ url('../../../../assets/font/UnidreamLED.woff') format('woff'), local('UnidreamLED'),
  url('../../../../assets/font/UnidreamLED.woff');
  /***默认使用本地的***/
}
</style>
<style lang="scss" scoped>
.water-box {
  width: 100%;
  height: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  .headers {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 98%;

    .site-img {
      width: 355px;
      height: 200px;
      border-radius: 10px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }

    .site-right {
      height: 22vh;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      width: 75.5%;

      .site-info {
        width: 100%;
        // width: 1150px;
        height: 16vh;
        // border: 1px solid #1890ff;
        display: flex;
        flex-direction: column;
        background-color: #15346b;
        // align-items: center;
        border-radius: 10px;
        color: #fff;
        animation: name 1s linear;

        .site-info-detail {
          display: flex;
          // flex-direction: column;
          margin-left: 20px;
          margin-top: 5px;

          // width: 220px;
          // padding: 0px 15px;
          .site-info-detail-top {
            display: flex;
            align-items: center;

            .icon-ziyuan1392 {
              font-size: 2.2rem;
              color: #fff;
              margin-right: 20px;
            }

            .site-name {
              font-size: 1.2rem;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              max-width: 500px;
            }
          }

          .site-info-detail-center {
            display: flex;
            align-items: center;
            margin: 0 30px;
            margin-top: 10px;

            .icon-area {
              font-size: 1rem;
              color: #0ff;
            }

            .site-name {
              font-size: 0.8rem;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-left: 8px;
              font-family: 'UnidreamLED';
            }
          }

          .site-info-detail-bottom {
            display: flex;
            align-items: center;
            margin-top: 10px;

            .icon-heliu {
              font-size: 1rem;
              color: #0ff;
            }

            .site-name {
              font-size: 0.8rem;
              overflow: hidden;
              white-space: nowrap;
              margin-left: 8px;
              text-overflow: ellipsis;
              font-family: 'UnidreamLED';
            }
          }
        }

        .site-info-tab {
          width: 100%;
          height: 6vh;
          background: #4374e0;
          color: #fff;
          border-radius: 20px;
          margin-left: 15px;
          display: flex;

          .site-tab-left {
            width: 40%;
            height: 93%;
            margin-top: 2%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #fff;
            border-right: 1px solid #fff;

            // color: #0ff;
            .icon-shishidaping {
              font-size: 2.4rem;
            }

            .site-tab-name {
              font-size: 1.1rem;
            }
          }

          .site-tab-right {
            width: 60%;
            height: 100%;

            .site-tab-title {
              width: 95%;
              height: 50%;
              line-height: 50px;
              text-align: center;
              border-bottom: 1px solid #fff;
              font-family: 'UnidreamLED';
              font-size: 1.3rem;
              color: #0ff;
            }

            .site-tab-num {
              width: 95%;
              height: 50%;
              line-height: 50px;
              text-align: center;
              color: #0ff;
            }
          }
        }
      }

      .site-nav {
        width: 100%;
        height: 5vh;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;

        .nav-item {
          width: 150px;
          height: 5vh;
          position: relative;
          top: 10px;
          background-image: url(../../../../assets/others/index/bor1.png);
          background-size: 100% 100%;
          font-size: 1rem;
          line-height: 4.5vh;
          color: #1890ff;
          text-align: center;
          margin: 0 10px;
          cursor: pointer;
          user-select: none;
          animation: name 1s linear;

          &:hover {
            font-weight: bold;
            color: aqua;
          }

          &.current {
            font-weight: bold;
            color: aqua;
          }
        }
      }
    }
  }

  .tab-content {
    width: 100%;
    height: 64vh;
    margin-top: 1vh;
    overflow-y: auto;
    overflow-x: hidden;
    border-top: 1px solid #2c58a6;
  }
}

.site-items {
  display: flex;
  height: 9vh;
  align-items: center;
  justify-content: center;
  // margin-left: 30px;
  // overflow: hidden;
}

.site-items:last-child {
  width: 190px;
}

.site-details {
  display: flex;
  flex-direction: column;
  /*line-height: 37px;*/
  justify-content: space-around;
  height: 9vh;
  margin-left: 20px;
}

.content-label {
  position: absolute;
  top: 200px;
  right: 0px;
  display: flex;
  flex-direction: column;
  color: #f0fdfd;
  background: #4d78da;
  padding: 5px;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  line-height: 15px;
  justify-content: center;
  text-align: center;
  cursor: pointer;
}
</style>
